import { render, staticRenderFns } from "./vendorArchives.vue?vue&type=template&id=4a4e5ec8&scoped=true"
import script from "./vendorArchives.vue?vue&type=script&lang=js"
export * from "./vendorArchives.vue?vue&type=script&lang=js"
import style0 from "./vendorArchives.vue?vue&type=style&index=0&id=4a4e5ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e5ec8",
  null
  
)

export default component.exports